
<mat-expansion-panel class="study-dicom">
    <mat-expansion-panel-header class="study-header">
        <div class="header">
            <feedback [status]="study.status" (delete)="onDeleteStudy()"></feedback>
            <div class="row">
                <!-- Action -->
                <div class="col-action">
                    <mat-checkbox [ngModel]="study.status.selected"
                                  [disabled]="study.status.sendingStatus === 'SENT'"
                                  color="primary"
                                  (click)="preventAccordionClick($event)"
                                  (ngModelChange)="toggle()">
                    </mat-checkbox>
                </div>

                <div class="col-action-delete">
                    <button mat-icon-button
                            matTooltip="Delete"
                            (click)="onDelete($event)"> 
                        <mat-icon>delete</mat-icon>
                    </button>
                </div>

                <!-- PId -->
                <div class="col-pid">
                    <p>{{study.data.patient.id  || '--'}}</p>
                </div>

                <!-- Patient -->
                <div class="col-patient">
                    <p>{{study.data.patient.name  || '--'}}</p>
                    <p>{{study.data.patient.birthDate | date: 'dd/MM/YYYY'  || '--'}}</p>
                    <p>{{study.data.patient.sex  || '--'}}</p>
                </div>

                <!-- Description -->
                <div class="col-description">{{study.data.description}}</div>

                <!-- Accession Number -->
                <div class="col-acc-number">
                    <p>{{study.data.accessionId || '--'}}</p>
                    <p>{{'Series' | translate}} : {{study.data.series.length}}</p>
                    <p>{{'Files' | translate}} : {{study.data.filesNumber}}</p>
                </div>

                <!-- Date -->
                <div class="col-date">{{study.data.date | date: 'dd/MM/YYYY'  || '--'}} {{study.data.time }}</div>

                <!-- Modality -->
                <div class="col-modality">{{joinedModalities}}</div>

            </div>
        </div>
    </mat-expansion-panel-header>
    <div *ngFor="let series of study.data.series; let islast = last">
        <div [ngClass]="{'last-series': islast}">
            <series [series]="series" ></series>    
        </div>
    </div>
</mat-expansion-panel>



